export default __webpack_public_path__ + "static/media/00.7c6b9ed7.jpg";